import { _Country } from './countries.model';

export const countrieData: _Country[] = [
  {
    name: 'Afghanistan (‫افغانستان‬‎)',
    acronym: 'AF',
    capital: 'Kabul',
    region: 'AS',
    currency: {
      code: 'AFN',
      name: 'Afghan afghani',
      symbol: '؋',
    },
    language: {
      code: 'ps',
      name: 'Pashto',
    },
    dialling_code: '+93',
    isoCode: '004',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Albania (Shqipëri)',
    acronym: 'AL',
    capital: 'Tirana',
    region: 'EU',
    currency: {
      code: 'ALL',
      name: 'Albanian lek',
      symbol: 'L',
    },
    language: {
      code: 'sq',
      name: 'Albanian',
    },
    dialling_code: '+355',
    isoCode: '008',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Algeria (‫الجزائر‬‎)',
    acronym: 'DZ',
    capital: 'Algiers',
    region: 'AF',
    currency: {
      code: 'DZD',
      name: 'Algerian dinar',
      symbol: 'د.ج',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+213',
    isoCode: '012',
    phoneMask: '00-000-0000',
  },
  {
    name: 'American Samoa',
    acronym: 'AS',
    capital: 'Pago Pago',
    region: 'OC',
    currency: {
      code: 'USD',
      name: 'United State Dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '016',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Andorra',
    acronym: 'AD',
    capital: 'Andorra la Vella',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'ca',
      name: 'Catalan',
    },
    dialling_code: '+376',
    isoCode: '020',
    phoneMask: '000-000',
  },
  {
    name: 'Angola',
    acronym: 'AO',
    capital: 'Luanda',
    region: 'AF',
    currency: {
      code: 'AOA',
      name: 'Angolan kwanza',
      symbol: 'Kz',
    },
    language: {
      code: 'pt',
      name: 'Portuguese',
    },
    dialling_code: '+244',
    isoCode: '024',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Anguilla',
    acronym: 'AI',
    capital: 'The Valley',
    region: 'NA',
    currency: {
      code: 'XCD',
      name: 'East Caribbean dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '660',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Antigua and Barbuda',
    acronym: 'AG',
    capital: "Saint John's",
    region: 'NA',
    currency: {
      code: 'XCD',
      name: 'East Caribbean dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '028',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Argentina',
    acronym: 'AR',
    capital: 'Buenos Aires',
    region: 'SA',
    currency: {
      code: 'ARS',
      name: 'Argentine peso',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+54',
    isoCode: '032',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Armenia (Հայաստան)',
    acronym: 'AM',
    capital: 'Yerevan',
    region: 'AS',
    currency: {
      code: 'AMD',
      name: 'Armenian dram',
    },
    language: {
      code: 'hy',
      name: 'Armenian',
    },
    dialling_code: '+374',
    isoCode: '051',
    phoneMask: '00-000-000',
  },
  {
    name: 'Aruba',
    acronym: 'AW',
    capital: 'Oranjestad',
    region: 'SA',
    currency: {
      code: 'AWG',
      name: 'Aruban florin',
      symbol: 'ƒ',
    },
    language: {
      code: 'nl',
      name: 'Dutch',
    },
    dialling_code: '+297',
    isoCode: '533',
    phoneMask: '000-0000',
  },
  {
    name: 'Australia',
    acronym: 'AU',
    capital: 'Canberra',
    region: 'OC',
    currency: {
      code: 'AUD',
      name: 'Australian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+61',
    isoCode: '036',
    phoneMask: '0-0000-0000',
  },
  {
    name: 'Azerbaijan (Azərbaycan)',
    acronym: 'AZ',
    capital: 'Baku',
    region: 'AS',
    currency: {
      code: 'AZN',
      name: 'Azerbaijani manat',
    },
    language: {
      code: 'az',
      name: 'Azerbaijani',
    },
    dialling_code: '+994',
    isoCode: '031',
    phoneMask: '00-000-00-00',
  },
  {
    name: 'Bahamas',
    acronym: 'BS',
    capital: 'Nassau',
    region: 'NA',
    currency: {
      code: 'BSD',
      name: 'Bahamian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '044',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Bahrain (‫البحرين‬‎)',
    acronym: 'BH',
    capital: 'Manama',
    region: 'AS',
    currency: {
      code: 'BHD',
      name: 'Bahraini dinar',
      symbol: '.د.ب',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+973',
    isoCode: '048',
    phoneMask: '0000-0000',
  },
  {
    name: 'Bangladesh (বাংলাদেশ)',
    acronym: 'BD',
    capital: 'Dhaka',
    region: 'AS',
    currency: {
      code: 'BDT',
      name: 'Bangladeshi taka',
      symbol: '৳',
    },
    language: {
      code: 'bn',
      name: 'Bengali',
    },
    dialling_code: '+880',
    isoCode: '050',
    phoneMask: '00-000-000',
  },
  {
    name: 'Barbados',
    acronym: 'BB',
    capital: 'Bridgetown',
    region: 'NA',
    currency: {
      code: 'BBD',
      name: 'Barbadian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '052',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Belarus (Беларусь)',
    acronym: 'BY',
    capital: 'Minsk',
    region: 'EU',
    currency: {
      code: 'BYN',
      name: 'New Belarusian ruble',
      symbol: 'Br',
    },
    language: {
      code: 'be',
      name: 'Belarusian',
    },
    dialling_code: '+375',
    isoCode: '112',
    phoneMask: '(00) 000-00-00',
  },
  {
    name: 'Belgium (België)',
    acronym: 'BE',
    capital: 'Brussels',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'nl',
      name: 'Dutch',
    },
    dialling_code: '+32',
    isoCode: '056',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Belize',
    acronym: 'BZ',
    capital: 'Belmopan',
    region: 'NA',
    currency: {
      code: 'BZD',
      name: 'Belize dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+501',
    isoCode: '084',
    phoneMask: '000-0000',
  },
  {
    name: 'Benin (Bénin)',
    acronym: 'BJ',
    capital: 'Porto-Novo',
    region: 'AF',
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+229',
    isoCode: '204',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Bermuda',
    acronym: 'BM',
    capital: 'Hamilton',
    region: 'NA',
    currency: {
      code: 'BMD',
      name: 'Bermudian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '060',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Bhutan (འབྲུག)',
    acronym: 'BT',
    capital: 'Thimphu',
    region: 'AS',
    currency: {
      code: 'BTN',
      name: 'Bhutanese ngultrum',
      symbol: 'Nu.',
    },
    language: {
      code: 'dz',
      name: 'Dzongkha',
    },
    dialling_code: '+975',
    isoCode: '064',
    phoneMask: '00-000-000 || 0-000-000',
  },
  {
    name: 'Bolivia (Plurinational State of)',
    acronym: 'BO',
    capital: 'Sucre',
    region: 'SA',
    currency: {
      code: 'BOB',
      name: 'Bolivian boliviano',
      symbol: 'Bs.',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+591',
    isoCode: '068',
    phoneMask: '0-000-0000',
  },
  {
    name: 'Bosnia and Herzegovina (Босна и Херцеговина)',
    acronym: 'BA',
    capital: 'Sarajevo',
    region: 'EU',
    currency: {
      code: 'BAM',
      name: 'Bosnia and Herzegovina convertible mark',
    },
    language: {
      code: 'bs',
      name: 'Bosnian',
    },
    dialling_code: '+387',
    isoCode: '070',
    phoneMask: '00-00000 || 00-0000',
  },
  {
    name: 'Botswana',
    acronym: 'BW',
    capital: 'Gaborone',
    region: 'AF',
    currency: {
      code: 'BWP',
      name: 'Botswana pula',
      symbol: 'P',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+267',
    isoCode: '072',
    phoneMask: '00-000-000',
  },
  {
    name: 'Brazil (Brasil)',
    acronym: 'BR',
    capital: 'Brasília',
    region: 'SA',
    currency: {
      code: 'BRL',
      name: 'Brazilian real',
      symbol: 'R$',
    },
    language: {
      code: 'pt',
      name: 'Portuguese',
    },
    dialling_code: '+55',
    isoCode: '076',
    phoneMask: '(00) 0000-0000 || (00) 0000-0000 || (00) 00000-0000',
  },
  {
    name: 'British Indian Ocean Territory',
    acronym: 'IO',
    capital: 'Diego Garcia',
    region: 'AF',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+246',
    isoCode: '086',
    phoneMask: '000-0000',
  },
  {
    name: 'Virgin Islands (British)',
    acronym: 'VG',
    capital: 'Road Town',
    region: 'NA',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '092',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Virgin Islands (U.S.)',
    acronym: 'VI',
    capital: 'Charlotte Amalie',
    region: 'NA',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '850',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Brunei Darussalam',
    acronym: 'BN',
    capital: 'Bandar Seri Begawan',
    region: 'AS',
    currency: {
      code: 'BND',
      name: 'Brunei dollar',
      symbol: '$',
    },
    language: {
      code: 'ms',
      name: 'Malay',
    },
    dialling_code: '+673',
    isoCode: '096',
    phoneMask: '000-0000',
  },
  {
    name: 'Bulgaria (България)',
    acronym: 'BG',
    capital: 'Sofia',
    region: 'EU',
    currency: {
      code: 'BGN',
      name: 'Bulgarian lev',
      symbol: 'лв',
    },
    language: {
      code: 'bg',
      name: 'Bulgarian',
    },
    dialling_code: '+359',
    isoCode: '100',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Burkina Faso',
    acronym: 'BF',
    capital: 'Ouagadougou',
    region: 'AF',
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+226',
    isoCode: '854',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Burundi (Uburundi)',
    acronym: 'BI',
    capital: 'Bujumbura',
    region: 'AF',
    currency: {
      code: 'BIF',
      name: 'Burundian franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+257',
    isoCode: '108',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Cambodia (កម្ពុជា)',
    acronym: 'KH',
    capital: 'Phnom Penh',
    region: 'AS',
    currency: {
      code: 'KHR',
      name: 'Cambodian riel',
      symbol: '៛',
    },
    language: {
      code: 'km',
      name: 'Khmer',
    },
    dialling_code: '+855',
    isoCode: '116',
    phoneMask: '00-000-000',
  },
  {
    name: 'Cameroon (Cameroun)',
    acronym: 'CM',
    capital: 'Yaoundé',
    region: 'AF',
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+237',
    isoCode: '120',
    phoneMask: '0000-0000',
  },
  {
    name: 'Canada',
    acronym: 'CA',
    capital: 'Ottawa',
    region: 'NA',
    currency: {
      code: 'CAD',
      name: 'Canadian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '124',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Cape Verde (Kabu Verdi)',
    acronym: 'CV',
    capital: 'Praia',
    region: 'AF',
    currency: {
      code: 'CVE',
      name: 'Cape Verdean escudo',
      symbol: 'Esc',
    },
    language: {
      code: 'pt',
      iso639_2: 'por',
      name: 'Portuguese',
      nativeName: 'Português',
    },
    dialling_code: '+238',
    isoCode: '132',
    phoneMask: '(000) 00-00',
  },
  {
    name: 'Cayman Islands',
    acronym: 'KY',
    capital: 'George Town',
    region: 'NA',
    demonym: 'Caymanian',
    currency: {
      code: 'KYD',
      name: 'Cayman Islands dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '136',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Central African Republic (République centrafricaine)',
    acronym: 'CF',
    capital: 'Bangui',
    region: 'AF',
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+236',
    isoCode: '140',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Chile',
    acronym: 'CL',
    capital: 'Santiago',
    region: 'SA',
    currency: {
      code: 'CLP',
      name: 'Chilean peso',
      symbol: '$',
    },
    language: {
      code: 'es',
      iso639_2: 'spa',
      name: 'Spanish',
      nativeName: 'Español',
    },
    dialling_code: '+56',
    isoCode: '152',
    phoneMask: '0-0000-0000',
  },
  {
    name: 'China (中国)',
    acronym: 'CN',
    capital: 'Beijing',
    region: 'AS',
    currency: {
      code: 'CNY',
      name: 'Chinese yuan',
      symbol: '¥',
    },
    language: {
      code: 'zh',
      name: 'Chinese',
    },
    dialling_code: '+86',
    isoCode: '156',
    phoneMask: '(000) 0000-0000 || (000) 0000-000 || 00-00000-00000',
  },
  {
    name: 'Colombia',
    acronym: 'CO',
    capital: 'Bogotá',
    region: 'SA',
    currency: {
      code: 'COP',
      name: 'Colombian peso',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+57',
    isoCode: '170',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Comoros (‫جزر القمر‬‎)',
    acronym: 'KM',
    capital: 'Moroni',
    region: 'AF',
    currency: {
      code: 'KMF',
      name: 'Comorian franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+269',
    isoCode: '174',
    phoneMask: '00-00000',
  },
  {
    name: 'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
    acronym: 'CG',
    capital: 'Brazzaville',
    region: 'AF',
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+242',
    isoCode: '178',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Congo (Republic) (Congo-Brazzaville)',
    acronym: 'CD',
    capital: 'Kinshasa',
    region: 'AF',
    currency: {
      code: 'CDF',
      name: 'Congolese franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+243',
    isoCode: '180',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Cook Islands',
    acronym: 'CK',
    capital: 'Avarua',
    region: 'OC',
    currency: {
      code: 'NZD',
      name: 'New Zealand dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+682',
    isoCode: '184',
    phoneMask: '00-000',
  },
  {
    name: 'Costa Rica',
    acronym: 'CR',
    capital: 'San José',
    region: 'NA',
    currency: {
      code: 'CRC',
      name: 'Costa Rican colón',
      symbol: '₡',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+506',
    isoCode: '188',
    phoneMask: '0000-0000',
  },
  {
    name: 'Croatia (Hrvatska)',
    acronym: 'HR',
    capital: 'Zagreb',
    region: 'EU',
    currency: {
      code: 'HRK',
      name: 'Croatian kuna',
      symbol: 'kn',
    },
    language: {
      code: 'hr',
      name: 'Croatian',
    },
    dialling_code: '+385',
    isoCode: '191',
    phoneMask: '00-000-000',
  },
  {
    name: 'Cuba',
    acronym: 'CU',
    capital: 'Havana',
    region: 'NA',
    currency: {
      code: 'CUC',
      name: 'Cuban convertible peso',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+53',
    isoCode: '192',
    phoneMask: '0-000-0000',
  },
  {
    name: 'Cyprus (Κύπρος)',
    acronym: 'CY',
    capital: 'Nicosia',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'tr',
      name: 'Turkish',
    },
    dialling_code: '+357',
    isoCode: '196',
    phoneMask: '00-000-000',
  },
  {
    name: 'Czech Republic (Česká republika)',
    acronym: 'CZ',
    capital: 'Prague',
    region: 'EU',
    currency: {
      code: 'CZK',
      name: 'Czech koruna',
      symbol: 'Kč',
    },
    language: {
      code: 'cs',
      name: 'Czech',
    },
    dialling_code: '+420',
    isoCode: '203',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Denmark (Danmark)',
    acronym: 'DK',
    capital: 'Copenhagen',
    region: 'EU',
    currency: {
      code: 'DKK',
      name: 'Danish krone',
      symbol: 'kr',
    },
    language: {
      code: 'da',
      name: 'Danish',
    },
    dialling_code: '+45',
    isoCode: '208',
    phoneMask: '00-00-00-00',
  },
  {
    name: 'Djibouti',
    acronym: 'DJ',
    capital: 'Djibouti',
    region: 'AF',
    currency: {
      code: 'DJF',
      name: 'Djiboutian franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+253',
    isoCode: '262',
    phoneMask: '00-00-00-00',
  },
  {
    name: 'Dominica',
    acronym: 'DM',
    capital: 'Roseau',
    region: 'NA',
    currency: {
      code: 'XCD',
      name: 'East Caribbean dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '212',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Dominican Republic (República Dominicana)',
    acronym: 'DO',
    capital: 'Santo Domingo',
    region: 'NA',
    currency: {
      code: 'DOP',
      name: 'Dominican peso',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+1',
    isoCode: '214',
    phoneMask: '(000) 000-0000 || (000) 000-0000 || (000) 000-0000',
  },
  {
    name: 'Ecuador',
    acronym: 'EC',
    capital: 'Quito',
    region: 'SA',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+593',
    isoCode: '218',
    phoneMask: '00-000-0000 || 0-000-0000',
  },
  {
    name: 'Egypt (‫مصر‬‎)',
    acronym: 'EG',
    capital: 'Cairo',
    region: 'AF',
    currency: {
      code: 'EGP',
      name: 'Egyptian pound',
      symbol: '£',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+20',
    isoCode: '818',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'El Salvador',
    acronym: 'SV',
    capital: 'San Salvador',
    region: 'NA',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+503',
    isoCode: '222',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Equatorial Guinea (Guinea Ecuatorial)',
    acronym: 'GQ',
    capital: 'Malabo',
    region: 'AF',
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'es',
      iso639_2: 'spa',
      name: 'Spanish',
      nativeName: 'Español',
    },
    dialling_code: '+240',
    isoCode: '226',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Eritrea',
    acronym: 'ER',
    capital: 'Asmara',
    region: 'AF',
    currency: {
      code: 'ERN',
      name: 'Eritrean nakfa',
      symbol: 'Nfk',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+291',
    isoCode: '232',
    phoneMask: '0-000-000',
  },
  {
    name: 'Estonia (Eesti)',
    acronym: 'EE',
    capital: 'Tallinn',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'et',
      name: 'Estonian',
    },
    dialling_code: '+372',
    isoCode: '233',
    phoneMask: '0000-0000 || 000-0000',
  },
  {
    name: 'Ethiopia',
    acronym: 'ET',
    capital: 'Addis Ababa',
    region: 'AF',
    currency: {
      code: 'ETB',
      name: 'Ethiopian birr',
      symbol: 'Br',
    },
    language: {
      code: 'am',
      name: 'Amharic',
    },
    dialling_code: '+251',
    isoCode: '231',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Falkland Islands (Islas Malvinas)',
    acronym: 'FK',
    capital: 'Stanley',
    region: 'SA',
    currency: {
      code: 'FKP',
      name: 'Falkland Islands pound',
      symbol: '£',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+500',
    isoCode: '238',
    phoneMask: '00000',
  },
  {
    name: 'Faroe Islands (Føroyar)',
    acronym: 'FO',
    capital: 'Tórshavn',
    region: 'EU',
    currency: {
      code: 'DKK',
      name: 'Danish krone',
      symbol: 'kr',
    },
    language: {
      code: 'fo',
      name: 'Faroese',
    },
    dialling_code: '+298',
    isoCode: '234',
    phoneMask: '000-000',
  },
  {
    name: 'Fiji',
    acronym: 'FJ',
    capital: 'Suva',
    region: 'OC',
    currency: {
      code: 'FJD',
      name: 'Fijian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+679',
    isoCode: '242',
    phoneMask: '00-00000',
  },
  {
    name: 'Finland (Suomi)',
    acronym: 'FI',
    capital: 'Helsinki',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fi',
      iso639_2: 'fin',
      name: 'Finnish',
      nativeName: 'suomi',
    },
    dialling_code: '+358',
    isoCode: '246',
    phoneMask: '(000) 000-00-00',
  },
  {
    name: 'France',
    acronym: 'FR',
    capital: 'Paris',
    region: 'EU',
    demonym: 'French',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+33',
    isoCode: '250',
    phoneMask: '00 00 00 00 00 || 00000-0000 || (000) 000-000 || 00-0000 || (000) 000-000',
  },
  {
    name: 'French Guiana (Guyane française)',
    acronym: 'GF',
    capital: 'Cayenne',
    region: 'SA',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+594',
    isoCode: '254',
    phoneMask: '00000-0000',
  },
  {
    name: 'French Polynesia (Polynésie française)',
    acronym: 'PF',
    capital: 'Papeetē',
    region: 'OC',
    currency: {
      code: 'XPF',
      name: 'CFP franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+689',
    isoCode: '258',
    phoneMask: '00-00-00',
  },
  {
    name: 'Gabon',
    acronym: 'GA',
    capital: 'Libreville',
    region: 'AF',
    currency: {
      code: 'XAF',
      name: 'Central African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+241',
    isoCode: '266',
    phoneMask: '0-00-00-00',
  },
  {
    name: 'Gambia',
    acronym: 'GM',
    capital: 'Banjul',
    region: 'AF',
    currency: {
      code: 'GMD',
      name: 'Gambian dalasi',
      symbol: 'D',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+220',
    isoCode: '270',
    phoneMask: '(000) 00-00',
  },
  {
    name: 'Georgia (საქართველო)',
    acronym: 'GE',
    capital: 'Tbilisi',
    region: 'AS',
    currency: {
      code: 'GEL',
      name: 'Georgian Lari',
      symbol: 'ლ',
    },
    language: {
      code: 'ka',
      name: 'Georgian',
    },
    dialling_code: '+995',
    isoCode: '268',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Germany (Deutschland)',
    acronym: 'DE',
    capital: 'Berlin',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'de',
      name: 'German',
    },
    dialling_code: '+49',
    isoCode: '276',
    phoneMask: '(0000) 000-0000 || (000) 000-0000 || (000) 00-0000 || (000) 00-000 || (000) 00-00 || 000-000',
  },
  {
    name: 'Ghana (Gaana)',
    acronym: 'GH',
    capital: 'Accra',
    region: 'AF',
    currency: {
      code: 'GHS',
      name: 'Ghanaian cedi',
      symbol: '₵',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+233',
    isoCode: '288',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Gibraltar',
    acronym: 'GI',
    capital: 'Gibraltar',
    region: 'EU',
    currency: {
      code: 'GIP',
      name: 'Gibraltar pound',
      symbol: '£',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+350',
    isoCode: '292',
    phoneMask: '000-00000',
  },
  {
    name: 'Greece (Ελλάδα)',
    acronym: 'GR',
    capital: 'Athens',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'el',
      name: 'Greek (modern)',
    },
    dialling_code: '+30',
    isoCode: '300',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Greenland (Kalaallit Nunaat)',
    acronym: 'GL',
    capital: 'Nuuk',
    region: 'NA',
    currency: {
      code: 'DKK',
      name: 'Danish krone',
      symbol: 'kr',
    },
    language: {
      code: 'kl',
      name: 'Kalaallisut',
    },
    dialling_code: '+299',
    isoCode: '304',
    phoneMask: '00-00-00',
  },
  {
    name: 'Grenada',
    acronym: 'GD',
    capital: "St. George's",
    region: 'NA',
    currency: {
      code: 'XCD',
      name: 'East Caribbean dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '308',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Guadeloupe',
    acronym: 'GP',
    capital: 'Basse-Terre',
    region: 'NA',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+590',
    isoCode: '312',
    phoneMask: '000 00 00 00',
  },
  {
    name: 'Guam',
    acronym: 'GU',
    capital: 'Hagåtña',
    region: 'OC',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '316',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Guatemala',
    acronym: 'GT',
    capital: 'Guatemala City',
    region: 'NA',
    currency: {
      code: 'GTQ',
      name: 'Guatemalan quetzal',
      symbol: 'Q',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+502',
    isoCode: '320',
    phoneMask: '0-000-0000',
  },
  {
    name: 'Guinea (Guinée)',
    acronym: 'GN',
    capital: 'Conakry',
    region: 'AF',
    currency: {
      code: 'GNF',
      name: 'Guinean franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+224',
    isoCode: '324',
    phoneMask: '00-000-000',
  },
  {
    name: 'Guinea-Bissau (Guiné Bissau)',
    acronym: 'GW',
    capital: 'Bissau',
    region: 'AF',
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'pt',
      name: 'Portuguese',
    },
    dialling_code: '+245',
    isoCode: '624',
    phoneMask: '0-000000',
  },
  {
    name: 'Guyana',
    acronym: 'GY',
    capital: 'Georgetown',
    region: 'SA',
    currency: {
      code: 'GYD',
      name: 'Guyanese dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+592',
    isoCode: '328',
    phoneMask: '000-0000',
  },
  {
    name: 'Haiti',
    acronym: 'HT',
    capital: 'Port-au-Prince',
    region: 'Americas',
    currency: {
      code: 'HTG',
      name: 'Haitian gourde',
      symbol: 'G',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+509',
    isoCode: '332',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Holy See',
    acronym: 'VA',
    capital: 'Rome',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+39',
    isoCode: '336',
    phoneMask: '0-000-00000',
  },
  {
    name: 'Honduras',
    acronym: 'HN',
    capital: 'Tegucigalpa',
    region: 'NA',
    currency: {
      code: 'HNL',
      name: 'Honduran lempira',
      symbol: 'L',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+504',
    isoCode: '340',
    phoneMask: '0000-0000',
  },
  {
    name: 'Hong Kong (香港)',
    acronym: 'HK',
    capital: 'City of Victoria',
    region: 'AS',
    currency: {
      code: 'HKD',
      name: 'Hong Kong dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+852',
    isoCode: '344',
    phoneMask: '0000-0000',
  },
  {
    name: 'Hungary (Magyarország)',
    acronym: 'HU',
    capital: 'Budapest',
    region: 'EU',
    currency: {
      code: 'HUF',
      name: 'Hungarian forint',
      symbol: 'Ft',
    },
    language: {
      code: 'hu',
      name: 'Hungarian',
    },
    dialling_code: '+36',
    isoCode: '348',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Iceland (Ísland)',
    acronym: 'IS',
    capital: 'Reykjavík',
    region: 'EU',
    currency: {
      code: 'ISK',
      name: 'Icelandic króna',
      symbol: 'kr',
    },
    language: {
      code: 'is',
      name: 'Icelandic',
    },
    dialling_code: '+354',
    isoCode: '352',
    phoneMask: '000-0000',
  },
  {
    name: 'India (भारत)',
    acronym: 'IN',
    capital: 'New Delhi',
    region: 'AS',
    currency: {
      code: 'INR',
      name: 'Indian rupee',
      symbol: '₹',
    },
    language: {
      code: 'hi',
      name: 'Hindi',
    },
    dialling_code: '+91',
    isoCode: '356',
    phoneMask: '(0000) 000-000',
  },
  {
    name: 'Indonesia',
    acronym: 'ID',
    capital: 'Jakarta',
    region: 'AS',
    currency: {
      code: 'IDR',
      name: 'Indonesian rupiah',
      symbol: 'Rp',
    },
    language: {
      code: 'id',
      name: 'Indonesian',
    },
    dialling_code: '+62',
    isoCode: '360',
    phoneMask: '(000) 000-0000 || 00-000-00 || 00-000-000 || 00-000-0000 || (000) 000-000 || (000) 000-00-000',
  },
  {
    name: "Côte d'Ivoire",
    acronym: 'CI',
    capital: 'Yamoussoukro',
    region: 'AF',
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+225',
    isoCode: '384',
    phoneMask: '00-000-000',
  },
  {
    name: 'Iran (‫ایران‬‎)',
    acronym: 'IR',
    capital: 'Tehran',
    region: 'AS',
    currency: {
      code: 'IRR',
      name: 'Iranian rial',
      symbol: '﷼',
    },
    language: {
      code: 'fa',
      name: 'Persian (Farsi)',
    },
    dialling_code: '+98',
    isoCode: '364',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Iraq (‫العراق‬‎)',
    acronym: 'IQ',
    capital: 'Baghdad',
    region: 'AS',
    currency: {
      code: 'IQD',
      name: 'Iraqi dinar',
      symbol: 'ع.د',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+964',
    isoCode: '368',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Ireland',
    acronym: 'IE',
    capital: 'Dublin',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'ga',
      name: 'Irish',
    },
    dialling_code: '+353',
    isoCode: '372',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Israel (‫ישראל‬‎)',
    acronym: 'IL',
    capital: 'Jerusalem',
    region: 'AS',
    currency: {
      code: 'ILS',
      name: 'Israeli new shekel',
      symbol: '₪',
    },
    language: {
      code: 'he',
      name: 'Hebrew (modern)',
    },
    dialling_code: '+972',
    isoCode: '376',
    phoneMask: '00-000-0000 || 0-000-0000',
  },
  {
    name: 'Italy (Italia)',
    acronym: 'IT',
    capital: 'Rome',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'it',
      name: 'Italian',
    },
    dialling_code: '+39',
    isoCode: '380',
    phoneMask: '(000) 0000-000',
  },
  {
    name: 'Jamaica',
    acronym: 'JM',
    capital: 'Kingston',
    region: 'NA',
    currency: {
      code: 'JMD',
      name: 'Jamaican dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '388',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Japan (日本)',
    acronym: 'JP',
    capital: 'Tokyo',
    region: 'AS',
    currency: {
      code: 'JPY',
      name: 'Japanese yen',
      symbol: '¥',
    },
    language: {
      code: 'ja',
      name: 'Japanese',
    },
    dialling_code: '+81',
    isoCode: '392',
    phoneMask: '00-0000-0000 || (000) 000-000',
  },
  {
    name: 'Jordan (‫الأردن‬‎)',
    acronym: 'JO',
    capital: 'Amman',
    region: 'AS',
    currency: {
      code: 'JOD',
      name: 'Jordanian dinar',
      symbol: 'د.ا',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+962',
    isoCode: '400',
    phoneMask: '0-0000-0000',
  },
  {
    name: 'Kazakhstan (Казахстан)',
    acronym: 'KZ',
    capital: 'Astana',
    region: 'AS',
    currency: {
      code: 'KZT',
      name: 'Kazakhstani tenge',
    },
    language: {
      code: 'kk',
      name: 'Kazakh',
    },
    dialling_code: '+7',
    isoCode: '398',
    phoneMask: '(000) 000-00-00 || (000) 000-00-00',
  },
  {
    name: 'Kenya',
    acronym: 'KE',
    capital: 'Nairobi',
    region: 'AF',
    currency: {
      code: 'KES',
      name: 'Kenyan shilling',
      symbol: 'Sh',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+254',
    isoCode: '404',
    phoneMask: '000-000000',
  },
  {
    name: 'Kiribati',
    acronym: 'KI',
    capital: 'South Tarawa',
    region: 'OC',
    currency: {
      code: 'AUD',
      name: 'Australian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+686',
    isoCode: '296',
    phoneMask: '00-000',
  },
  {
    name: 'Kuwait (‫الكويت‬‎)',
    acronym: 'KW',
    capital: 'Kuwait City',
    region: 'AS',
    currency: {
      code: 'KWD',
      name: 'Kuwaiti dinar',
      symbol: 'د.ك',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+965',
    isoCode: '414',
    phoneMask: '0000-0000',
  },
  {
    name: 'Kyrgyzstan (Кыргызстан)',
    acronym: 'KG',
    capital: 'Bishkek',
    region: 'AS',
    currency: {
      code: 'KGS',
      name: 'Kyrgyzstani som',
      symbol: 'с',
    },
    language: {
      code: 'ky',
      name: 'Kyrgyz',
    },
    dialling_code: '+996',
    isoCode: '417',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Laos (ລາວ)',
    acronym: 'LA',
    capital: 'Vientiane',
    region: 'AS',
    currency: {
      code: 'LAK',
      name: 'Lao kip',
      symbol: '₭',
    },
    language: {
      code: 'lo',
      name: 'Lao',
    },
    dialling_code: '+856',
    isoCode: '418',
    phoneMask: '(0000) 000-000 || 00-000-000',
  },
  {
    name: 'Latvia (Latvija)',
    acronym: 'LV',
    capital: 'Riga',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'lv',
      name: 'Latvian',
    },
    dialling_code: '+371',
    isoCode: '428',
    phoneMask: '00-000-000',
  },
  {
    name: 'Lebanon (‫لبنان‬‎)',
    acronym: 'LB',
    capital: 'Beirut',
    region: 'AS',
    currency: {
      code: 'LBP',
      name: 'Lebanese pound',
      symbol: 'ل.ل',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+961',
    isoCode: '422',
    phoneMask: '00-000-000 || 0-000-000',
  },
  {
    name: 'Lesotho',
    acronym: 'LS',
    capital: 'Maseru',
    region: 'AF',
    currency: {
      code: 'LSL',
      name: 'Lesotho loti',
      symbol: 'L',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+266',
    isoCode: '426',
    phoneMask: '0-000-0000',
  },
  {
    name: 'Liberia',
    acronym: 'LR',
    capital: 'Monrovia',
    region: 'AF',
    currency: {
      code: 'LRD',
      name: 'Liberian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+231',
    isoCode: '430',
    phoneMask: '00-000-000',
  },
  {
    name: 'Libya (‫ليبيا‬‎)',
    acronym: 'LY',
    capital: 'Tripoli',
    region: 'AF',
    currency: {
      code: 'LYD',
      name: 'Libyan dinar',
      symbol: 'ل.د',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+218',
    isoCode: '434',
    phoneMask: '00-000-000 || 00-000-0000',
  },
  {
    name: 'Liechtenstein',
    acronym: 'LI',
    capital: 'Vaduz',
    region: 'EU',
    currency: {
      code: 'CHF',
      name: 'Swiss franc',
      symbol: 'Fr',
    },
    language: {
      code: 'de',
      name: 'German',
    },
    dialling_code: '+423',
    isoCode: '438',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Lithuania (Lietuva)',
    acronym: 'LT',
    capital: 'Vilnius',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'lt',
      name: 'Lithuanian',
    },
    dialling_code: '+370',
    isoCode: '440',
    phoneMask: '(000) 00-000',
  },
  {
    name: 'Luxembourg',
    acronym: 'LU',
    capital: 'Luxembourg',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+352',
    isoCode: '442',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Macau (澳門)',
    acronym: 'MO',
    capital: '',
    region: 'AS',
    currency: {
      code: 'MOP',
      name: 'Macanese pataca',
      symbol: 'P',
    },
    language: {
      code: 'zh',
      name: 'Chinese',
    },
    dialling_code: '+853',
    isoCode: '446',
    phoneMask: '0000-0000',
  },
  {
    name: 'Macedonia (the former Yugoslav Republic of)',
    acronym: 'MK',
    capital: 'Skopje',
    region: 'EU',
    currency: {
      code: 'MKD',
      name: 'Macedonian denar',
      symbol: 'ден',
    },
    language: {
      code: 'mk',
      name: 'Macedonian',
    },
    dialling_code: '+389',
    isoCode: '807',
    phoneMask: '00-000-000',
  },
  {
    name: 'Madagascar (Madagasikara)',
    acronym: 'MG',
    capital: 'Antananarivo',
    region: 'AF',
    currency: {
      code: 'MGA',
      name: 'Malagasy ariary',
      symbol: 'Ar',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+261',
    isoCode: '450',
    phoneMask: '00-00-00000',
  },
  {
    name: 'Malawi',
    acronym: 'MW',
    capital: 'Lilongwe',
    region: 'AF',
    currency: {
      code: 'MWK',
      name: 'Malawian kwacha',
      symbol: 'MK',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+265',
    isoCode: '454',
    phoneMask: '0-000-000 || 0-0000-0000',
  },
  {
    name: 'Malaysia',
    acronym: 'MY',
    capital: 'Kuala Lumpur',
    region: 'AS',
    currency: {
      code: 'MYR',
      name: 'Malaysian ringgit',
      symbol: 'RM',
    },
    language: {
      code: 'MY',
      name: 'Malaysian',
    },
    dialling_code: '+60',
    isoCode: '458',
    phoneMask: '00-000-0000 || (000) 000-000 || 00-000-000 || 0-000-000',
  },
  {
    name: 'Maldives',
    acronym: 'MV',
    capital: 'Malé',
    region: 'AS',
    currency: {
      code: 'MVR',
      name: 'Maldivian rufiyaa',
      symbol: '.ރ',
    },
    language: {
      code: 'dv',
      name: 'Divehi',
    },
    dialling_code: '+960',
    isoCode: '462',
    phoneMask: '000-0000',
  },
  {
    name: 'Mali',
    acronym: 'ML',
    capital: 'Bamako',
    region: 'AF',
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+223',
    isoCode: '466',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Malta',
    acronym: 'MT',
    capital: 'Valletta',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'mt',
      name: 'Maltese',
    },
    dialling_code: '+356',
    isoCode: '470',
    phoneMask: '0000-0000',
  },
  {
    name: 'Marshall Islands',
    acronym: 'MH',
    capital: 'Majuro',
    region: 'OC',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+692',
    isoCode: '584',
    phoneMask: '000-0000',
  },
  {
    name: 'Martinique',
    acronym: 'MQ',
    capital: 'Fort-de-France',
    region: 'Americas',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+596',
    isoCode: '474',
    phoneMask: '(000) 00-00-00',
  },
  {
    name: 'Mauritania (‫موريتانيا‬‎)',
    acronym: 'MR',
    capital: 'Nouakchott',
    region: 'AF',
    currency: {
      code: 'MRO',
      name: 'Mauritanian ouguiya',
      symbol: 'UM',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+222',
    isoCode: '478',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Mauritius (Moris)',
    acronym: 'MU',
    capital: 'Port Louis',
    region: 'AF',
    currency: {
      code: 'MUR',
      name: 'Mauritian rupee',
      symbol: '₨',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+230',
    isoCode: '480',
    phoneMask: '000-0000',
  },
  {
    name: 'Mayotte',
    acronym: 'YT',
    capital: 'Mamoudzou',
    region: 'AF',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+262',
    isoCode: '175',
    phoneMask: '0000 00 00 00',
  },
  {
    name: 'Mexico (México)',
    acronym: 'MX',
    capital: 'Mexico City',
    region: 'NA',
    currency: {
      code: 'MXN',
      name: 'Mexican peso',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+52',
    isoCode: '484',
    phoneMask: '(000) 000-0000 || 00-00-0000',
  },
  {
    name: 'Micronesia (Federated States of)',
    acronym: 'FM',
    capital: 'Palikir',
    region: 'OC',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+691',
    isoCode: '583',
    phoneMask: '000-0000',
  },
  {
    name: 'Moldova (Republica Moldova)',
    acronym: 'MD',
    capital: 'Chișinău',
    region: 'EU',
    currency: {
      code: 'MDL',
      name: 'Moldovan leu',
      symbol: 'L',
    },
    language: {
      code: 'ro',
      name: 'Romanian',
    },
    dialling_code: '+373',
    isoCode: '498',
    phoneMask: '0000-0000',
  },
  {
    name: 'Monaco',
    acronym: 'MC',
    capital: 'Monaco',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+377',
    isoCode: '492',
    phoneMask: '(000) 000-000 || 00-000-000',
  },
  {
    name: 'Mongolia (Монгол)',
    acronym: 'MN',
    capital: 'Ulan Bator',
    region: 'AS',
    currency: {
      code: 'MNT',
      name: 'Mongolian tögrög',
      symbol: '₮',
    },
    language: {
      code: 'mn',
      name: 'Mongolian',
    },
    dialling_code: '+976',
    isoCode: '496',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Montenegro (Crna Gora)',
    acronym: 'ME',
    capital: 'Podgorica',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'sr',
      name: 'Serbian',
    },
    dialling_code: '+382',
    isoCode: '499',
    phoneMask: '00-000-000',
  },
  {
    name: 'Montserrat',
    acronym: 'MS',
    capital: 'Plymouth',
    region: 'NA',
    currency: {
      code: 'XCD',
      name: 'East Caribbean dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '500',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Morocco (‫المغرب‬‎)',
    acronym: 'MA',
    capital: 'Rabat',
    region: 'AF',
    currency: {
      code: 'MAD',
      name: 'Moroccan dirham',
      symbol: 'د.م.',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+212',
    isoCode: '504',
    phoneMask: '00-0000-000',
  },
  {
    name: 'Mozambique (Moçambique)',
    acronym: 'MZ',
    capital: 'Maputo',
    region: 'AF',
    currency: {
      code: 'MZN',
      name: 'Mozambican metical',
      symbol: 'MT',
    },
    language: {
      code: 'pt',
      name: 'Portuguese',
    },
    dialling_code: '+258',
    isoCode: '508',
    phoneMask: '00-000-000',
  },
  {
    name: 'Myanmar (Burma) (မြန်မာ)',
    acronym: 'MM',
    capital: 'Naypyidaw',
    region: 'AS',
    currency: {
      code: 'MMK',
      name: 'Burmese kyat',
      symbol: 'Ks',
    },
    language: {
      code: 'my',
      name: 'Burmese',
    },
    dialling_code: '+95',
    isoCode: '104',
    phoneMask: '00-000-000 || 0-000-000 || 000-000',
  },
  {
    name: 'Namibia (Namibië)',
    acronym: 'NA',
    capital: 'Windhoek',
    region: 'AF',
    currency: {
      code: 'NAD',
      name: 'Namibian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+264',
    isoCode: '516',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Nauru',
    acronym: 'NR',
    capital: 'Yaren',
    region: 'OC',
    currency: {
      code: 'AUD',
      name: 'Australian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+674',
    isoCode: '520',
    phoneMask: '000-0000',
  },
  {
    name: 'Nepal (नेपाल)',
    acronym: 'NP',
    capital: 'Kathmandu',
    region: 'AS',
    currency: {
      code: 'NPR',
      name: 'Nepalese rupee',
      symbol: '₨',
    },
    language: {
      code: 'ne',
      name: 'Nepali',
    },
    dialling_code: '+977',
    isoCode: '524',
    phoneMask: '00-000-000',
  },
  {
    name: 'Netherlands (Nederland)',
    acronym: 'NL',
    capital: 'Amsterdam',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'nl',
      name: 'Dutch',
    },
    dialling_code: '+31',
    isoCode: '528',
    phoneMask: '00-000-0000',
  },
  {
    name: 'New Caledonia (Nouvelle-Calédonie)',
    acronym: 'NC',
    capital: 'Nouméa',
    region: 'OC',
    currency: {
      code: 'XPF',
      name: 'CFP franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+687',
    isoCode: '540',
    phoneMask: '00-0000',
  },
  {
    name: 'New Zealand',
    acronym: 'NZ',
    capital: 'Wellington',
    region: 'OC',
    currency: {
      code: 'NZD',
      name: 'New Zealand dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+64',
    isoCode: '554',
    phoneMask: '(000) 000-000 || 00-000-000 || (000) 000-0000',
  },
  {
    name: 'Nicaragua',
    acronym: 'NI',
    capital: 'Managua',
    region: 'NA',
    currency: {
      code: 'NIO',
      name: 'Nicaraguan córdoba',
      symbol: 'C$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+505',
    isoCode: '558',
    phoneMask: '0000-0000',
  },
  {
    name: 'Niger (Nijar)',
    acronym: 'NE',
    capital: 'Niamey',
    region: 'AF',
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+227',
    isoCode: '562',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Nigeria',
    acronym: 'NG',
    capital: 'Abuja',
    region: 'AF',
    currency: {
      code: 'NGN',
      name: 'Nigerian naira',
      symbol: '₦',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+234',
    isoCode: '566',
    phoneMask: '(000) 000-0000 || 00-000-000 || 00-000-00 || (000) 000-0000',
  },
  {
    name: 'Niue',
    acronym: 'NU',
    capital: 'Alofi',
    region: 'OC',
    currency: {
      code: 'NZD',
      name: 'New Zealand dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+683',
    isoCode: '570',
    phoneMask: '0000',
  },
  {
    name: 'Norfolk Island',
    acronym: 'NF',
    capital: 'Kingston',
    region: 'OC',
    currency: {
      code: 'AUD',
      name: 'Australian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+672',
    isoCode: '574',
    phoneMask: '000-000',
  },
  {
    name: 'North Korea (조선 민주주의 인민 공화국)',
    acronym: 'KP',
    capital: 'Pyongyang',
    region: 'AS',
    currency: {
      code: 'KPW',
      name: 'North Korean won',
      symbol: '₩',
    },
    language: {
      code: 'ko',
      name: 'Korean',
    },
    dialling_code: '+850',
    isoCode: '408',
    phoneMask: '000-000-0000 || 00-000-000 || 000-0000-000 || 000-000 || 0000-0000 || 0000-0000000000000',
  },
  {
    name: 'Northern Mariana Islands',
    acronym: 'MP',
    capital: 'Saipan',
    region: 'OC',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '580',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Norway (Norge)',
    acronym: 'NO',
    capital: 'Oslo',
    region: 'EU',
    currency: {
      code: 'NOK',
      name: 'Norwegian krone',
      symbol: 'kr',
    },
    language: {
      code: 'no',
      name: 'Norwegian',
    },
    dialling_code: '+47',
    isoCode: '578',
    phoneMask: '(000) 00-000',
  },
  {
    name: 'Oman (‫عُمان‬‎)',
    acronym: 'OM',
    capital: 'Muscat',
    region: 'AS',
    currency: {
      code: 'OMR',
      name: 'Omani rial',
      symbol: 'ر.ع.',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+968',
    isoCode: '512',
    phoneMask: '00-000-000',
  },
  {
    name: 'Pakistan (‫پاکستان‬‎)',
    acronym: 'PK',
    capital: 'Islamabad',
    region: 'AS',
    currency: {
      code: 'PKR',
      name: 'Pakistani rupee',
      symbol: '₨',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+92',
    isoCode: '586',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Palau',
    acronym: 'PW',
    capital: 'Ngerulmud',
    region: 'OC',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+680',
    isoCode: '585',
    phoneMask: '000-0000',
  },
  {
    name: 'Palestine (‫فلسطين‬‎)',
    acronym: 'PS',
    capital: 'Ramallah',
    region: 'AS',
    currency: {
      code: 'ILS',
      name: 'Israeli new sheqel',
      symbol: '₪',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+970',
    isoCode: '275',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Panama (Panamá)',
    acronym: 'PA',
    capital: 'Panama City',
    region: 'NA',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+507',
    isoCode: '591',
    phoneMask: '000-0000',
  },
  {
    name: 'Papua New Guinea',
    acronym: 'PG',
    capital: 'Port Moresby',
    region: 'OC',
    currency: {
      code: 'PGK',
      name: 'Papua New Guinean kina',
      symbol: 'K',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+675',
    isoCode: '598',
    phoneMask: '(000) 00-000',
  },
  {
    name: 'Paraguay',
    acronym: 'PY',
    capital: 'Asunción',
    region: 'SA',
    currency: {
      code: 'PYG',
      name: 'Paraguayan guaraní',
      symbol: '₲',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+595',
    isoCode: '600',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Peru (Perú)',
    acronym: 'PE',
    capital: 'Lima',
    region: 'SA',
    currency: {
      code: 'PEN',
      name: 'Peruvian sol',
      symbol: 'S/.',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+51',
    isoCode: '604',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Philippines',
    acronym: 'PH',
    capital: 'Manila',
    region: 'AS',
    currency: {
      code: 'PHP',
      name: 'Philippine peso',
      symbol: '₱',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+63',
    isoCode: '608',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Poland (Polska)',
    acronym: 'PL',
    capital: 'Warsaw',
    region: 'EU',
    currency: {
      code: 'PLN',
      name: 'Polish złoty',
      symbol: 'zł',
    },
    language: {
      code: 'pl',
      name: 'Polish',
    },
    dialling_code: '+48',
    isoCode: '616',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Portugal',
    acronym: 'PT',
    capital: 'Lisbon',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'pt',
      name: 'Portuguese',
    },
    dialling_code: '+351',
    isoCode: '620',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Puerto Rico',
    acronym: 'PR',
    capital: 'San Juan',
    region: 'NA',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+1',
    isoCode: '630',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Qatar (‫قطر‬‎)',
    acronym: 'QA',
    capital: 'Doha',
    region: 'AS',
    currency: {
      code: 'QAR',
      name: 'Qatari riyal',
      symbol: 'ر.ق',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+974',
    isoCode: '634',
    phoneMask: '0000-0000',
  },
  {
    name: 'Republic of Kosovo',
    acronym: 'XK',
    capital: 'Pristina',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'sq',
      name: 'Albanian',
    },
    dialling_code: '+383',
    isoCode: '383',
    phoneMask: '00 000 000',
  },
  {
    name: 'Réunion (La Réunion)',
    acronym: 'RE',
    capital: 'Saint-Denis',
    region: 'AF',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+262',
    isoCode: '638',
    phoneMask: '00000-0000',
  },
  {
    name: 'Romania (România)',
    acronym: 'RO',
    capital: 'Bucharest',
    region: 'EU',
    currency: {
      code: 'RON',
      name: 'Romanian leu',
      symbol: 'lei',
    },
    language: {
      code: 'ro',
      name: 'Romanian',
    },
    dialling_code: '+40',
    isoCode: '642',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Russia (Россия)',
    acronym: 'RU',
    capital: 'Moscow',
    region: 'EU',
    currency: {
      code: 'RUB',
      name: 'Russian ruble',
      symbol: '₽',
    },
    language: {
      code: 'ru',
      name: 'Russian',
    },
    dialling_code: '+7',
    isoCode: '643',
    phoneMask: '(000) 000-00-00',
  },
  {
    name: 'Rwanda',
    acronym: 'RW',
    capital: 'Kigali',
    region: 'AF',
    currency: {
      code: 'RWF',
      name: 'Rwandan franc',
      symbol: 'Fr',
    },
    language: {
      code: 'rw',
      name: 'Kinyarwanda',
    },
    dialling_code: '+250',
    isoCode: '646',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Saint Martin (Saint-Martin (partie française))',
    acronym: 'BL',
    capital: 'Gustavia',
    region: 'NA',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+590',
    isoCode: '652',
    phoneMask: '000 00 00 00',
  },
  {
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    acronym: 'SH',
    capital: 'Jamestown',
    region: 'AF',
    currency: {
      code: 'SHP',
      name: 'Saint Helena pound',
      symbol: '£',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+290',
    isoCode: '654',
    phoneMask: '0000 || 0000',
  },
  {
    name: 'Saint Kitts and Nevis',
    acronym: 'KN',
    capital: 'Basseterre',
    region: 'NA',
    currency: {
      code: 'XCD',
      name: 'East Caribbean dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '659',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Saint Lucia',
    acronym: 'LC',
    capital: 'Castries',
    region: 'NA',
    currency: {
      code: 'XCD',
      name: 'East Caribbean dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '662',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Saint Martin (French part)',
    acronym: 'MF',
    capital: 'Marigot',
    region: 'NA',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+590',
    isoCode: '663',
    phoneMask: '000 00 00 00',
  },
  {
    name: 'Saint Pierre and Miquelon',
    acronym: 'PM',
    capital: 'Saint-Pierre',
    region: 'NA',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+508',
    isoCode: '666',
    phoneMask: '00 00 00 || 000 00 00 00',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    acronym: 'VC',
    capital: 'Kingstown',
    region: 'NA',
    currency: {
      code: 'XCD',
      name: 'East Caribbean dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '670',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Samoa',
    acronym: 'WS',
    capital: 'Apia',
    region: 'OC',
    currency: {
      code: 'WST',
      name: 'Samoan tālā',
      symbol: 'T',
    },
    language: {
      code: 'sm',
      name: 'Samoan',
    },
    dialling_code: '+685',
    isoCode: '882',
    phoneMask: '00-0000',
  },
  {
    name: 'San Marino',
    acronym: 'SM',
    capital: 'City of San Marino',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'it',
      name: 'Italian',
    },
    dialling_code: '+378',
    isoCode: '674',
    phoneMask: '0000-000000',
  },
  {
    name: 'São Tomé and Príncipe (São Tomé e Príncipe)',
    acronym: 'ST',
    capital: 'São Tomé',
    region: 'AF',
    currency: {
      code: 'STD',
      name: 'São Tomé and Príncipe dobra',
      symbol: 'Db',
    },
    language: {
      code: 'pt',
      name: 'Portuguese',
    },
    dialling_code: '+239',
    isoCode: '678',
    phoneMask: '00-00000',
  },
  {
    name: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)',
    acronym: 'SA',
    capital: 'Riyadh',
    region: 'AS',
    currency: {
      code: 'SAR',
      name: 'Saudi riyal',
      symbol: 'ر.س',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+966',
    isoCode: '682',
    phoneMask: '0-0000-0000 || 0-000-0000',
  },
  {
    name: 'Senegal (Sénégal)',
    acronym: 'SN',
    capital: 'Dakar',
    region: 'AF',
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+221',
    isoCode: '686',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Serbia (Србија)',
    acronym: 'RS',
    capital: 'Belgrade',
    region: 'EU',
    currency: {
      code: 'RSD',
      name: 'Serbian dinar',
      symbol: 'дин.',
    },
    language: {
      code: 'sr',
      name: 'Serbian',
    },
    dialling_code: '+381',
    isoCode: '688',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Seychelles',
    acronym: 'SC',
    capital: 'Victoria',
    region: 'AF',
    currency: {
      code: 'SCR',
      name: 'Seychellois rupee',
      symbol: '₨',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+248',
    isoCode: '690',
    phoneMask: '0-000-000',
  },
  {
    name: 'Sierra Leone',
    acronym: 'SL',
    capital: 'Freetown',
    region: 'AF',
    currency: {
      code: 'SLL',
      name: 'Sierra Leonean leone',
      symbol: 'Le',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+232',
    isoCode: '694',
    phoneMask: '00-000000',
  },
  {
    name: 'Singapore',
    acronym: 'SG',
    capital: 'Singapore',
    region: 'AS',
    currency: {
      code: 'SGD',
      name: 'Singapore dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+65',
    isoCode: '702',
    phoneMask: '0000-0000',
  },
  {
    name: 'Slovakia (Slovensko)',
    acronym: 'SK',
    capital: 'Bratislava',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'sk',
      name: 'Slovak',
    },
    dialling_code: '+421',
    isoCode: '703',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Slovenia (Slovenija)',
    acronym: 'SI',
    capital: 'Ljubljana',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'sl',
      name: 'Slovene',
    },
    dialling_code: '+386',
    isoCode: '705',
    phoneMask: '00-000-000',
  },
  {
    name: 'Solomon Islands',
    acronym: 'SB',
    capital: 'Honiara',
    region: 'OC',
    currency: {
      code: 'SBD',
      name: 'Solomon Islands dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+677',
    isoCode: '090',
    phoneMask: '000-0000 || 00000',
  },
  {
    name: 'Somalia (Soomaaliya)',
    acronym: 'SO',
    capital: 'Mogadishu',
    region: 'AF',
    currency: {
      code: 'SOS',
      name: 'Somali shilling',
      symbol: 'Sh',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+252',
    isoCode: '706',
    phoneMask: '00-000-000 || 0-000-000 || 0-000-000',
  },
  {
    name: 'South Africa',
    acronym: 'ZA',
    capital: 'Pretoria',
    region: 'AF',
    currency: {
      code: 'ZAR',
      name: 'South African rand',
      symbol: 'R',
    },
    language: {
      code: 'en',
      iso639_2: 'eng',
      name: 'English',
      nativeName: 'English',
    },
    dialling_code: '+27',
    isoCode: '710',
    phoneMask: '00-000-0000',
  },
  {
    name: 'South Korea (대한민국)',
    acronym: 'KR',
    capital: 'Seoul',
    region: 'AS',
    currency: {
      code: 'KRW',
      name: 'South Korean won',
      symbol: '₩',
    },
    language: {
      code: 'ko',
      name: 'Korean',
    },
    dialling_code: '+82',
    isoCode: '410',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Spain',
    acronym: 'ES',
    capital: 'Madrid',
    region: 'EU',
    currency: {
      code: 'EUR',
      name: 'Euro',
      symbol: '€',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+34',
    isoCode: '724',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Sri Lanka (ශ්‍රී ලංකාව)',
    acronym: 'LK',
    capital: 'Colombo',
    region: 'AS',
    currency: {
      code: 'LKR',
      name: 'Sri Lankan rupee',
      symbol: 'Rs',
    },
    language: {
      code: 'si',
      iso639_2: 'sin',
      name: 'Sinhalese',
      nativeName: 'සිංහල',
    },
    dialling_code: '+94',
    isoCode: '144',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Sudan (‫السودان‬‎)',
    acronym: 'SD',
    capital: 'Khartoum',
    region: 'AF',
    currency: {
      code: 'SDG',
      name: 'Sudanese pound',
      symbol: 'ج.س.',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+249',
    isoCode: '729',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Suriname',
    acronym: 'SR',
    capital: 'Paramaribo',
    region: 'SA',
    currency: {
      code: 'SRD',
      name: 'Surinamese dollar',
      symbol: '$',
    },
    language: {
      code: 'nl',
      name: 'Dutch',
    },
    dialling_code: '+597',
    isoCode: '740',
    phoneMask: '000-0000 || 000-000',
  },
  {
    name: 'Swaziland',
    acronym: 'SZ',
    capital: 'Lobamba',
    region: 'AF',
    currency: {
      code: 'SZL',
      name: 'Swazi lilangeni',
      symbol: 'L',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+268',
    isoCode: '748',
    phoneMask: '00-00-0000',
  },
  {
    name: 'Sweden (Sverige)',
    acronym: 'SE',
    capital: 'Stockholm',
    region: 'EU',
    currency: {
      code: 'SEK',
      name: 'Swedish krona',
      symbol: 'kr',
    },
    language: {
      code: 'sv',
      name: 'Swedish',
    },
    dialling_code: '+46',
    isoCode: '752',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Switzerland (Schweiz)',
    acronym: 'CH',
    capital: 'Bern',
    region: 'EU',
    currency: {
      code: 'CHF',
      name: 'Swiss franc',
      symbol: 'Fr',
    },
    language: {
      code: 'de',
      name: 'German',
    },
    dialling_code: '+41',
    isoCode: '756',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Syria (‫سوريا‬‎)',
    acronym: 'SY',
    capital: 'Damascus',
    region: 'AS',
    currency: {
      code: 'SYP',
      name: 'Syrian pound',
      symbol: '£',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+963',
    isoCode: '760',
    phoneMask: '00-0000-000',
  },
  {
    name: 'Taiwan (台灣)',
    acronym: 'TW',
    capital: 'Taipei',
    region: 'AS',
    currency: {
      code: 'TWD',
      name: 'New Taiwan dollar',
      symbol: '$',
    },
    language: {
      code: 'zh',
      name: 'Chinese',
    },
    dialling_code: '+886',
    isoCode: '158',
    phoneMask: '0-0000-0000 || 0000-0000',
  },
  {
    name: 'Tajikistan',
    acronym: 'TJ',
    capital: 'Dushanbe',
    region: 'AS',
    currency: {
      code: 'TJS',
      name: 'Tajikistani somoni',
      symbol: 'ЅМ',
    },
    language: {
      code: 'tg',
      name: 'Tajik',
    },
    dialling_code: '+992',
    isoCode: '762',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Tanzania, United Republic of',
    acronym: 'TZ',
    capital: 'Dodoma',
    region: 'AF',
    currency: {
      code: 'TZS',
      name: 'Tanzanian shilling',
      symbol: 'Sh',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+255',
    isoCode: '834',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Thailand',
    acronym: 'TH',
    capital: 'Bangkok',
    region: 'AS',
    currency: {
      code: 'THB',
      name: 'Thai baht',
      symbol: '฿',
    },
    language: {
      code: 'th',
      name: 'Thai',
    },
    dialling_code: '+66',
    isoCode: '764',
    phoneMask: '00-000-0000 || 00-000-000',
  },
  {
    name: 'Timor-Leste',
    acronym: 'TL',
    capital: 'Dili',
    region: 'AS',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'pt',
      name: 'Portuguese',
    },
    dialling_code: '+670',
    isoCode: '626',
    phoneMask: '000-0000 || 000-00000 || 000-00000',
  },
  {
    name: 'Togo',
    acronym: 'TG',
    capital: 'Lomé',
    region: 'AF',
    currency: {
      code: 'XOF',
      name: 'West African CFA franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+228',
    isoCode: '768',
    phoneMask: '00-000-000',
  },
  {
    name: 'Tokelau',
    acronym: 'TK',
    capital: 'Fakaofo',
    region: 'OC',
    currency: {
      code: 'NZD',
      name: 'New Zealand dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+690',
    isoCode: '772',
    phoneMask: '0000',
  },
  {
    name: 'Tonga',
    acronym: 'TO',
    capital: "Nuku'alofa",
    region: 'OC',
    currency: {
      code: 'TOP',
      name: 'Tongan paʻanga',
      symbol: 'T$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+676',
    isoCode: '776',
    phoneMask: '00000',
  },
  {
    name: 'Trinidad and Tobago',
    acronym: 'TT',
    capital: 'Port of Spain',
    region: 'SA',
    currency: {
      code: 'TTD',
      name: 'Trinidad and Tobago dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '780',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Tunisia (‫تونس‬‎)',
    acronym: 'TN',
    capital: 'Tunis',
    region: 'AF',
    currency: {
      code: 'TND',
      name: 'Tunisian dinar',
      symbol: 'د.ت',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+216',
    isoCode: '788',
    phoneMask: '00-000-000',
  },
  {
    name: 'Turkey (Türkiye)',
    acronym: 'TR',
    capital: 'Ankara',
    region: 'AS',
    currency: {
      code: 'TRY',
      name: 'Turkish lira',
    },
    language: {
      code: 'tr',
      name: 'Turkish',
    },
    dialling_code: '+90',
    isoCode: '792',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Turkmenistan',
    acronym: 'TM',
    capital: 'Ashgabat',
    region: 'AS',
    currency: {
      code: 'TMT',
      name: 'Turkmenistan manat',
      symbol: 'm',
    },
    language: {
      code: 'tk',
      name: 'Turkmen',
    },
    dialling_code: '+993',
    isoCode: '795',
    phoneMask: '0-000-0000',
  },
  {
    name: 'Turks and Caicos Islands',
    acronym: 'TC',
    capital: 'Cockburn Town',
    region: 'NA',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+1',
    isoCode: '796',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Tuvalu',
    acronym: 'TV',
    capital: 'Funafuti',
    region: 'OC',
    currency: {
      code: 'AUD',
      name: 'Australian dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+688',
    isoCode: '798',
    phoneMask: '000000 || 00000',
  },
  {
    name: 'Uganda',
    acronym: 'UG',
    capital: 'Kampala',
    region: 'AF',
    currency: {
      code: 'UGX',
      name: 'Ugandan shilling',
      symbol: 'Sh',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+256',
    isoCode: '800',
    phoneMask: '(000) 000-000',
  },
  {
    name: 'Ukraine (Україна)',
    acronym: 'UA',
    capital: 'Kyiv',
    region: 'EU',
    currency: {
      code: 'UAH',
      name: 'Ukrainian hryvnia',
      symbol: '₴',
    },
    language: {
      code: 'uk',
      name: 'Ukrainian',
    },
    dialling_code: '+380',
    isoCode: '804',
    phoneMask: '(00) 000-00-00',
  },
  {
    name: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)',
    acronym: 'AE',
    capital: 'Abu Dhabi',
    region: 'AS',
    currency: {
      code: 'AED',
      name: 'United Arab Emirates dirham',
      symbol: 'د.إ',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+971',
    isoCode: '784',
    phoneMask: '00-000-0000 || 0-000-0000',
  },
  {
    name: 'United Kingdom of Great Britain and Northern Ireland',
    acronym: 'UK',
    capital: 'London',
    region: 'EU',
    currency: {
      code: 'GBP',
      name: 'British pound',
      symbol: '£',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+44',
    isoCode: '826',
    phoneMask: '00-0000-0000',
  },
  {
    name: 'United States of America',
    acronym: 'US',
    capital: 'Washington, D.C.',
    region: 'NA',
    currency: {
      code: 'USD',
      name: 'United States dollar',
      symbol: '$',
    },
    language: {
      code: 'en',
      iso639_2: 'eng',
      name: 'English',
      nativeName: 'English',
    },
    dialling_code: '+1',
    isoCode: '840',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Uruguay',
    acronym: 'UY',
    capital: 'Montevideo',
    region: 'SA',
    currency: {
      code: 'UYU',
      name: 'Uruguayan peso',
      symbol: '$',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+598',
    isoCode: '858',
    phoneMask: '0-000-00-00',
  },
  {
    name: 'Uzbekistan (Oʻzbekiston)',
    acronym: 'UZ',
    capital: 'Tashkent',
    region: 'AS',
    currency: {
      code: 'UZS',
      name: "Uzbekistani so'm",
    },
    language: {
      code: 'uz',
      name: 'Uzbek',
    },
    dialling_code: '+998',
    isoCode: '860',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Vanuatu',
    acronym: 'VU',
    capital: 'Port Vila',
    region: 'OC',
    currency: {
      code: 'VUV',
      name: 'Vanuatu vatu',
      symbol: 'Vt',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+678',
    isoCode: '548',
    phoneMask: '00-00000 || 00000',
  },
  {
    name: 'Venezuela (Bolivarian Republic of)',
    acronym: 'VE',
    capital: 'Caracas',
    region: 'SA',
    currency: {
      code: 'VEF',
      name: 'Venezuelan bolívar',
      symbol: 'Bs F',
    },
    language: {
      code: 'es',
      name: 'Spanish',
    },
    dialling_code: '+58',
    isoCode: '862',
    phoneMask: '(000) 000-0000',
  },
  {
    name: 'Vietnam (Việt Nam)',
    acronym: 'VN',
    capital: 'Hanoi',
    region: 'AS',
    currency: {
      code: 'VND',
      name: 'Vietnamese đồng',
      symbol: '₫',
    },
    language: {
      code: 'vi',
      name: 'Vietnamese',
    },
    dialling_code: '+84',
    isoCode: '704',
    phoneMask: '00-0000-000 || (000) 0000-000',
  },
  {
    name: 'Wallis and Futuna (Wallis-et-Futuna)',
    acronym: 'WF',
    capital: 'Mata-Utu',
    region: 'OC',
    currency: {
      code: 'XPF',
      name: 'CFP franc',
      symbol: 'Fr',
    },
    language: {
      code: 'fr',
      name: 'French',
    },
    dialling_code: '+681',
    isoCode: '876',
    phoneMask: '00-0000',
  },
  {
    name: 'Yemen (‫اليمن‬‎)',
    acronym: 'YE',
    capital: "Sana'a",
    region: 'AS',
    currency: {
      code: 'YER',
      name: 'Yemeni rial',
      symbol: '﷼',
    },
    language: {
      code: 'ar',
      name: 'Arabic',
    },
    dialling_code: '+967',
    isoCode: '887',
    phoneMask: '000-000-000 || 0-000-000 || 00-000-000',
  },
  {
    name: 'Zambia',
    acronym: 'ZM',
    capital: 'Lusaka',
    region: 'AF',
    currency: {
      code: 'ZMW',
      name: 'Zambian kwacha',
      symbol: 'ZK',
    },
    language: {
      code: 'en',
      name: 'English',
    },
    dialling_code: '+260',
    isoCode: '894',
    phoneMask: '00-000-0000',
  },
  {
    name: 'Zimbabwe',
    acronym: 'ZW',
    capital: 'Harare',
    region: 'AF',
    currency: {
      code: 'BWP',
      name: 'Botswana pula',
      symbol: 'P',
    },
    language: {
      code: 'en',
      iso639_2: 'eng',
      name: 'English',
      nativeName: 'English',
    },
    dialling_code: '+263',
    isoCode: '716',
    phoneMask: '0-000000',
  },
];
